const SkeletonBar = ({ className = '' }: { className?: string }) => (
  <div className={`relative overflow-hidden rounded bg-white/10 ${className}`}>
    <div className='absolute inset-0 -translate-x-full animate-shimmer bg-linear-to-r from-transparent via-white/15 to-transparent' />
  </div>
)

const ProjectCardSkeleton = () => (
  <div className='rounded-[10px] overflow-hidden h-full flex flex-col bg-mostlyGreen'>
    <div className='relative w-full h-80 sm:h-[380px] md:h-60 lg:h-[410px] bg-darkGreen overflow-hidden'>
      <div className='absolute inset-0 -translate-x-full animate-shimmer bg-linear-to-r from-transparent via-white/10 to-transparent' />
    </div>
    <div className='flex-1 flex flex-col gap-[10px] p-5 md:p-[30px]'>
      <div className='flex flex-col flex-1 gap-[10px]'>
        <SkeletonBar className='h-6 w-3/4' />
        <SkeletonBar className='h-5 w-1/2' />
        <SkeletonBar className='h-5 w-1/3' />
      </div>
      <div className='flex flex-row gap-[5px] mt-2'>
        <SkeletonBar className='h-6 w-16' />
        <SkeletonBar className='h-6 w-20' />
      </div>
    </div>
  </div>
)

const ProjectGridSkeleton = () => (
  <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5'>
    {Array.from({ length: 9 }).map((_, i) => (
      <ProjectCardSkeleton key={i} />
    ))}
  </div>
)

export default ProjectGridSkeleton
